import CadastroVendedorModal from './CadastroVendedorModal';

export default CadastroVendedorModal;
